import { Component } from "react";
import "./../simpleDialog.css";
import "./WrongTimezoneWarning.css";
import AppDialog from "./../AppDialog/AppDialog";
import Action from "./../formElements/Action/Action";
import { LocationInput } from "./../LocationInput/LocationInput";
import { transformLocationResults, getTimezone } from "./../LocationInput/locationUtil";
import { geocodeByAddress } from "react-places-autocomplete";
import { getSessionUser, updateSessionUserProfile } from "./../../services/authUtil";
import { getAddressDescription } from "./../../services/util";
import { updateUserLocation } from "./../../services/users";
import { logInfo } from "./../../services/logging";
import { Trans, Translation } from "react-i18next";

export default class WrongTimezoneWarning extends Component {
  constructor(props) {
    super(props);

    this.currentUser = getSessionUser();

    this.state = {
      place: {
        description: getAddressDescription(this.currentUser.profile.address),
        placeId: "",
        lat: 0,
        lng: 0,
      },
      showSpinner: true,
      errors: "",
    };

    this.close = this.close.bind(this);
    this.ignore = this.ignore.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.handleLocationInput = this.handleLocationInput.bind(this);
    this.handleLocationSelect = this.handleLocationSelect.bind(this);

    this.detectUserLocation();
  }

  updateLocation() {
    logInfo("clicked on 'Update my Location' from Wrong Timezone warning");
    if (!this.currentAddress || !this.timezone) {
      logInfo("clicked 'Update Location' but there is no data");
      return;
    }
    this.setState({ showSpinner: true });
    updateUserLocation({ timezone: this.timezone, address: this.currentAddress })
      .then(() => {
        const profile = this.currentUser.profile;
        profile.timezone = this.timezone;
        profile.address = this.currentAddress;
        updateSessionUserProfile(profile);
        this.setState({ showSpinner: false });
        this.props.onClose();
      })
      .catch(errors => {
        this.setState({ errors: errors, showSpinner: false });
      });
  }

  ignore() {
    logInfo("clicked on 'Ignore' in Wrong Timezone warning");
    this.props.onClose();
  }

  close() {
    logInfo("Wrong Timezone warning is closing");
    this.props.onClose();
  }

  handleLocationInput(address) {
    const newPlace = this.state.place;
    newPlace.description = address;

    this.setState({
      place: newPlace,
    });
  }

  clearAddress(newAddr) {
    newAddr.city = "";
    newAddr.state = "";
    newAddr.country = "";
    newAddr.street_1 = "";
  }

  handleLocationSelect(address, placeId) {
    const newPlace = this.state.place;
    newPlace.description = address;
    newPlace.placeId = placeId;
    const newAddr = this.currentUser.profile.address;

    geocodeByAddress(address)
      .then(results => {
        this.clearAddress(newAddr);
        return transformLocationResults(newAddr, results);
      })
      .then(latLng => {
        this.currentAddress = newAddr;
        newPlace.lat = latLng.lat;
        newPlace.lng = latLng.lng;
        this.setState({
          place: newPlace,
        });
        getTimezone(latLng, timezone => (this.timezone = timezone));
      })
      .catch(error => {
        logInfo("error when changing user's location", {
          from: "WrongTimezoneWarning#handleLocationSelect",
          error: error,
        });
      });
  }

  geoCodeCallback = (results, status) => {
    const google = window.google;
    if (status === google.maps.GeocoderStatus.OK) {
      if (results && results[0]) {
        const newAddr = this.currentUser.profile.address;
        transformLocationResults(newAddr, results)
          .then(latLng => {
            this.currentAddress = newAddr;
            getTimezone(latLng, timezone => {
              this.timezone = timezone;
              this.setState({ showSpinner: false });
            });
            const newPlace = this.state.place;
            newPlace.description = getAddressDescription(newAddr);
            this.setState({ place: newPlace });
          })
          .catch(error => {
            logInfo("error when detecting user's location", {
              from: "WrongTimezoneWarning#geoCodeCallback",
              error: error,
            });
          });
      } else {
        // eslint-disable-next-line
        console.log("address not found");
      }
    } else {
      // eslint-disable-next-line
      console.log(status);
    }
  };

  geocodeAddress(geocoder, latlng) {
    geocoder.geocode({ location: latlng }, this.geoCodeCallback);
  }

  detectUserLocation() {
    // check for Geolocation support
    const google = window.google;
    if (navigator.geolocation) {
      this.displayLocation = (latitude, longitude) => {
        const geocoder = new google.maps.Geocoder();
        const latlng = new google.maps.LatLng(latitude, longitude);
        this.geocodeAddress(geocoder, latlng);
      };
      this.geoSuccess = position => {
        this.displayLocation(position.coords.latitude, position.coords.longitude);
      };
      this.geoError = error => {
        switch (error.code) {
          case error.TIMEOUT:
            // eslint-disable-next-line
            console.log("Browser geolocation error !\n\nTimeout.");
            break;
          case error.PERMISSION_DENIED:
            // eslint-disable-next-line
            console.log("Browser geolocation error !\n\nPermission denied.");
            break;
          case error.POSITION_UNAVAILABLE:
            // eslint-disable-next-line
            console.log("Browser geolocation error !\n\nPosition unavailable.");
            break;
          default:
            // eslint-disable-next-line
            console.log(error.code);
            break;
        }
        this.setState({ showSpinner: false });
      };
      navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError);
    } else {
      // eslint-disable-next-line
      console.log("Geolocation is not supported for this Browser/OS.");
      this.setState({ showSpinner: false });
    }
  }

  render() {
    const actions = this.state.showSpinner ? null : (
      <Translation>
        {t => (
          <div className="form-actions">
            <Action className="btn cancel" onClick={this.ignore}>
              {t("Common.Ignore")}
            </Action>
            <Action className="btn submit" onClick={this.updateLocation}>
              {t("Common.Update my Location")}
            </Action>
          </div>
        )}
      </Translation>
    );

    let location = null;
    if (!this.state.showSpinner) {
      location = LocationInput({
        value: this.state.place.description,
        handleLocationInput: this.handleLocationInput,
        handleLocationSelect: this.handleLocationSelect,
        className: "location-input",
      });
    }

    return (
      <AppDialog
        isValidForm={true}
        showDialog={this.props.showDialog}
        onClose={this.close}
        titleComponent={
          <>
            <Translation>{t => <h3>{t("Common.yourLocation")}</h3>}</Translation>
          </>
        }
        formActions={actions}
        topBorder={true}
        showSpinner={this.state.showSpinner}
        errors={this.state.errors}
        className="simple-dialog wrong-timezone"
      >
        <Trans i18nKey={"Common.yourLocationDesc"}>
          <p>
            Hi {{ firstName: this.currentUser.profile.first_name }}, it looks like your
            current location and time zone are different to the location saved in your
            profile. Would you like to update it?
          </p>
        </Trans>

        <div className="change-location-container">{location}</div>
      </AppDialog>
    );
  }
}
